import React from 'react';
import AnalyticsViewer from './AnalyticsViewer';

function AnalyticsPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <AnalyticsViewer />
        </div>
      </div>
    </div>
  );
}

export default AnalyticsPage;
